export const CREATING_CATEGORY = "CREATING_CATEGORY";
export const UPDATING_CATEGORY = "UPDATING_CATEGORY";
export const CATEGORY_CREATED = "CATEGORY_CREATED";
export const CATEGORY_UPDATED = "CATEGORY_UPDATED";
export const ERROR_CATEGORY_CREATE = "ERROR_CATEGORY_CREATE";
export const ERROR_CATEGORY_UPDATE = "ERROR_CATEGORY_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
